module.exports = __webpack_public_path__ + "img/fig16.f981c823.jpg";